<template>
  <!-- eslint-disable -->
  <div>
    <detalle-add :is-add.sync="isAdd" ref="detalleAdd"> </detalle-add>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" class="mb-md-0 mt-2">
          <b-button variant="gradient-danger" @click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-50" />
            <span class="align-middle">Atras</span>
          </b-button>
          </b-col>
          <b-col md="3" class="mb-md-0 mb-2 ml-5">
            <!-- @input="(val) => $emit('update:roleFilter', val)" -->
            <label>Descripción</label>
            <b-form-input v-model="name" placeholder="Descripción" @input="filter"/>
          </b-col>
          <b-col md="2" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>
          <b-col class="d-flex align-items-center justify-content-end">
          <!-- @click="isAddNewUserSidebarActive = true"< -->
          <b-button variant="primary" class="mt-2 mr-1" @click="addDetalle">
            <span class="text-nowrap">Agregar</span>
          </b-button>
        </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import detalleAdd from './detalleImportacionAdd.vue'
import DetailImportService from '@/services/DetailImportService'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      isAdd: false,
      isUpdate: false,
      name: '',
      arrayFilters: [],
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    detalleAdd
  },
  mounted() {
  },
  methods: {
    addDetalle(){
      this.isAdd = true
      this.$refs.detalleAdd.getData({})
    },
    back() {
      this.$router.push({ name: 'importacion-list' })
    },
    async filter() {
      this.arrayFilters = [];
      if (this.name !== '') {
        this.arrayFilters.push({
          keyContains: 'autpart.description',
          key: 'contains',
          value: this.name
        });
      }
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    clean() {
      this.name = '';
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
